// extracted by mini-css-extract-plugin
module.exports = {"container":"_2BEiLVXXKVMdG7urzJh6V-","logoLink":"_34HTLRcwNZaFDFlpX8vbC_","logoCaptionText":"_2y8CdaR3ybdEhXc5GueK9w","logoImage":"_1dNna8T5xaOjZCYvbiW8wX"};